module.exports = __webpack_public_path__ + "static/media/harry-potter-1.3d4e0b30.png";